import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useHeartbeat(user) {
    const timer = useRef(null);
    useEffect(() => {
        if (!user) {
            if (timer.current) clearInterval(timer.current);
            timer.current = null;
            return;
        }
        const ping = () => api.post("/presence/heartbeat").catch(() => {});
        ping();
        timer.current = setInterval(ping, 30000);
        return () => {
            if (timer.current) clearInterval(timer.current);
            timer.current = null;
        };
    }, [user]);
}

export function useOnlineCount() {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let alive = true;
        const fetchIt = async () => {
            try {
                const res = await api.get("/presence/online");
                if (alive) setCount(res.data.count || 0);
            } catch (e) { /* noop */ }
        };
        fetchIt();
        const id = setInterval(fetchIt, 15000);
        return () => { alive = false; clearInterval(id); };
    }, []);
    return count;
}
